import { BrowserRouter as Router, Routes, Route, Link, Navigate } from "react-router-dom";
import Register from "./pages/Register";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Profile from "./pages/Profile";
import PersonalLoanForm1 from "./pages/pl/Step1LoanAmountTenurePage";
import Step1LoanAmountTenurePage from "./pages/pl/Step1LoanAmountTenurePage";
import Step2BasicDetails from "./pages/pl/Step2BasicDetails";
import Step3EmploymentDetails from "./pages/pl/Step3EmploymentDetails";
import Step4SelectAccountAggregator from "./pages/pl/Step4SelectAccountAggregator";
import Step5ChooseOfferbyLenders from "./pages/pl/Step5ChooseOfferbyLenders";
import Step6OfferDetails from "./pages/pl/Step6OfferDetails";
import Step7HLKycPage from "./pages/pl/Step7HLKycPage";
import Step8LendersKycPage from "./pages/pl/Step8LendersKycPage";
import Step9BankDetails from "./pages/pl/Step9BankDetails";
import Step10EMandate from "./pages/pl/Step10EMandate";
import Step11ESign from "./pages/pl/Step11ESign";
import Step12LoanConfirmation from "./pages/pl/Step13LoanConfirmation";
import Step4TermNCondition from "./pages/pl/Step4TermNCondition";
import MyAccount from "./pages/profile/MyAccount";
import MyLoans from "./pages/profile/MyLoans";
import CustomerService from "./pages/profile/CustomerService";
import Step12UserConsent from "./pages/pl/Step12UserConsent";
import Step13LoanConfirmation from "./pages/pl/Step13LoanConfirmation";
import Sorry from "./pages/Sorry";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to="/login" />} />
        <Route path="/register" element={<Register />} />
        <Route path="/login" element={<Login />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/personal-loan" element={<Step1LoanAmountTenurePage />} />
        <Route path="/sorry" element={<Sorry />} />
        <Route path="/basic-details" element={<Step2BasicDetails />} />
        <Route path="/employment-details" element={<Step3EmploymentDetails />} />
        <Route path="/account-aggregator" element={<Step4SelectAccountAggregator />} />
        <Route path="/iagree" element={<Step4TermNCondition />} />
        <Route path="/offer-by-lenders" element={<Step5ChooseOfferbyLenders />} />
        <Route path="/offer-details" element={<Step6OfferDetails />} />
        <Route path="/get-hl-kyc" element={<Step7HLKycPage />} />
        <Route path="/get-lenders-kyc" element={<Step8LendersKycPage />} />
        <Route path="/bank-details" element={<Step9BankDetails />} />
        <Route path="/e-mandate" element={<Step10EMandate />} />
        <Route path="/e-sign" element={<Step11ESign />} />
        <Route path="/user-consent" element={<Step12UserConsent/>} />
        <Route path="/loan-confirmation" element={<Step13LoanConfirmation />} />
        <Route path="/my-account" element={<MyAccount />} />
        <Route path="/my-loans" element={<MyLoans />} />
        <Route path="/customer-service" element={<CustomerService />} />
      </Routes>
    </Router>
  );
};

export default App;
